import { jsx as _jsx } from "react/jsx-runtime";
import { BKJIcon } from '../BKJIcon/BKJIcon.js';
import { BKJTooltipWrapper } from '../BKJTooltipWrapper/index.js';
export const BKJIconTooltip = ({ children, ...props }) => {
    const Icon = () => _jsx(BKJIcon, { iconName: props.iconName });
    return (_jsx(BKJTooltipWrapper, { ...props, Component: Icon, children: children }));
};
//# sourceMappingURL=BKJIconTooltip.js.map